import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaMoon, FaSun } from 'react-icons/fa';

export default function Feedback() {
  const [dark, setDark] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const planId = location.state?.planId;

  const [type, setType] = useState('');
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async () => {
    if (!type) {
      setError('نوع بازخورد را انتخاب کنید.');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://api.mogym.ir/api/feedback/plan', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          PlanId: planId,
          Type: type,
          Comment: comment
        })
      });

      if (res.status === 200) {
        setSuccess(true);
      } else {
        const data = await res.json();
        setError(data.Message || 'خطا در ارسال بازخورد.');
      }
    } catch {
      setError('ارتباط با سرور برقرار نشد.');
    }
    setLoading(false);
  };

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-10 font-vazir">
        <div className="max-w-lg mx-auto bg-gray-50 dark:bg-[#1c1f2b] rounded-xl p-6 shadow">
          <h1 className="text-xl font-bold mb-4 text-center">ثبت بازخورد درباره برنامه</h1>

          {success ? (
            <div className="text-green-600 text-center">
              بازخورد شما با موفقیت ثبت شد. از همکاری شما متشکریم 🙏
              <div className="mt-6 text-center">
                <button
                  onClick={() => navigate('/dashboard')}
                  className="bg-blue-600 text-white px-5 py-2 rounded-xl"
                >
                  بازگشت به داشبورد
                </button>
              </div>
            </div>
          ) : (
            <>
              <label className="block mb-2 font-medium">نوع بازخورد:</label>
              <select
                value={type}
                onChange={(e) => setType(e.target.value)}
                className="w-full p-3 rounded-xl border dark:border-gray-600 bg-white dark:bg-[#2a2f3b] mb-4"
              >
                <option value="">انتخاب کنید</option>
                {/* WorkoutIssue,NutritionIssue,WrongPlan,Other */}
                <option value="1">مشکل در برنامه تمرینی</option>
                <option value="2">مشکل در برنامه غذایی</option>
                <option value="3">برنامه مناسب نیست</option>
                <option value="4">سایر</option>
              </select>

              <label className="block mb-2 font-medium">توضیحات (اختیاری):</label>
              <textarea
                rows="4"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="w-full p-3 rounded-xl border dark:border-gray-600 bg-white dark:bg-[#2a2f3b] mb-4"
                placeholder="اگر توضیح خاصی دارید بنویسید..."
              />

              {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

              <button
                onClick={handleSubmit}
                disabled={loading}
                className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl disabled:opacity-50"
              >
                {loading ? 'در حال ارسال...' : 'ارسال بازخورد'}
              </button>
            </>
          )}
        </div>

        {/* Toggle Theme */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button>
      </div>
    </div>
  );
}
